import { render, staticRenderFns } from "./AssessmentRule.vue?vue&type=template&id=4fb0f8c0"
import script from "./AssessmentRule.vue?vue&type=script&lang=js"
export * from "./AssessmentRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports